import type { Messages } from './en';

/** हिंदी — every key from en.ts must be present (TypeScript enforces it). */
export const hi: Messages = {
  app: {
    name: 'असेंबली रेडीनेस',
    product: 'SaarthiOS CLEAR',
    tagline: 'लाइन चलाने और असेंबली की तैयारी की जाँच',
  },
  common: {
    units: 'यूनिट',
    of: 'में से',
    back: 'वापस',
    cancel: 'रद्द करें',
    save: 'सेव करें',
    close: 'बंद करें',
    confirm: 'पक्का करें',
    undo: 'वापस लें',
    undone: 'वापस ले लिया',
    retry: 'फिर कोशिश करें',
    loading: 'लोड हो रहा है…',
    change: 'बदलें',
    edit: 'बदलें',
    add: 'जोड़ें',
    all: 'सभी',
    yes: 'हाँ',
    no: 'नहीं',
    today: 'आज',
    shift: 'शिफ्ट {code}',
    ext: 'एक्सटेंशन {ext}',
    call: 'कॉल करें',
    by: '{name} द्वारा',
    at: '{time} पर',
    delete: 'हटाएँ',
    show: 'दिखाएँ',
    none: '—',
    optional: 'ज़रूरी नहीं',
    somethingWrong: 'कुछ गड़बड़ हुई। फिर कोशिश करें।',
    notFound: 'पेज नहीं मिला',
    goHome: 'मेरे काम पर जाएँ',
    notAllowed: 'यह स्क्रीन आपकी भूमिका में नहीं है।',
    offlineRead: 'ऑफ़लाइन — आखिरी सेव डेटा दिख रहा है।',
  },
  roles: {
    planner: 'प्लानर',
    paint: 'पेंट',
    rm: 'RM',
    quality: 'क्वालिटी',
    supervisor: 'लाइन सुपरवाइज़र',
    mgmt: 'मैनेजमेंट',
    admin: 'एडमिन',
  },
  gates: {
    paint: 'पेंट',
    rm: 'RM',
    quality: 'क्वालिटी',
    short: { paint: 'P', rm: 'R', quality: 'Q' },
  },
  gateStatus: {
    ok: 'ठीक',
    partial: { paint: 'आंशिक', rm: 'आंशिक', quality: 'आंशिक रोक' },
    blocked: { paint: 'कमी', rm: 'उपलब्ध नहीं', quality: 'रोकें' },
    pending: 'अपडेट नहीं',
    locked: 'लॉक',
    observation: 'ठीक, टिप्पणी के साथ',
  },
  status: {
    READY: 'तैयार',
    PART: 'आंशिक तैयार',
    WAIT: 'इंतज़ार',
    HOLD: 'रुका',
    STARTED: 'शुरू',
    CANCELLED: 'रद्द',
  },
  priority: { high: 'ऊँची', normal: 'सामान्य', low: 'कम', highPriority: 'ऊँची प्राथमिकता' },
  login: {
    tapYourName: 'अपना नाम चुनें',
    enterPin: 'अपना 4 अंकों का PIN डालें',
    wrongPin: 'गलत PIN। {n} कोशिश बाकी, फिर खाता 15 मिनट के लिए लॉक होगा।',
    wrongPinShort: 'गलत PIN। फिर कोशिश करें।',
    locked: 'बहुत बार गलत PIN। {time} तक लॉक। एडमिन से अनलॉक करवाएँ।',
    notYou: 'आप नहीं हैं?',
    firstTime: 'पहली बार? अपना PIN बनाएँ',
    noPin: 'आपने अभी PIN नहीं बनाया है।',
    setUpNow: 'अभी बनाएँ',
    sharedDevice: '{label} · {role} का साझा डिवाइस',
    pairTitle: 'विभाग के साझा डिवाइस के रूप में सेट करें',
    pairHint: 'एडमिन → डिवाइस से मिला 6 अंकों का कोड डालें।',
    pairButton: 'डिवाइस जोड़ें',
    pairDone: 'यह डिवाइस अब {role} विभाग का है।',
    demoPin: 'हर यूज़र का डेमो PIN: {pin}',
    loginFailed: 'लॉग इन नहीं हुआ। कनेक्शन जाँचें और फिर कोशिश करें।',
    welcomeBack: 'फिर से स्वागत है',
    plantLine: '{plant} · {line} · {shift} · {date}',
  },
  setup: {
    title: 'पहली बार सेटअप',
    mobile: 'आपका मोबाइल नंबर',
    mobileHint: 'जो नंबर एडमिन ने आपके लिए दर्ज किया है।',
    sendOtp: 'कोड भेजें',
    otpSentTo: '{mobile} पर 6 अंकों का कोड भेजा गया है।',
    enterOtp: '6 अंकों का कोड डालें',
    demoOtp: 'डेमो कोड: {code}',
    verify: 'जाँचें',
    choosePin: '4 अंकों का PIN चुनें',
    confirmPin: 'वही PIN फिर से डालें',
    pinsDontMatch: 'दोनों PIN अलग हैं। फिर से शुरू करें।',
    weakPin: 'बहुत आसान है। दूसरा PIN चुनें।',
    done: 'PIN बन गया। आप लॉग इन हैं।',
    wrongOtp: 'गलत कोड। SMS देखकर फिर डालें।',
    expired: 'कोड की समय सीमा खत्म। नया कोड मँगाएँ।',
    resend: 'नया कोड भेजें',
    step: 'चरण {n} / 3',
  },
  shell: {
    noLine: 'कोई असेंबली लाइन चालू नहीं है',
    noLineHint:
      'लाइन चालू होने पर ही प्लान और काम की सूची दिखेगी। अपने Admin से सेटअप → लाइनें में एक लाइन चालू करवाएँ।',
    noLineAdmin: 'सेटअप → लाइनें में एक लाइन चालू करें, फिर Planner आज का प्लान प्रकाशित कर सकता है।',
    openLines: 'लाइनें खोलें',
    synced: 'सिंक हो गया',
    syncing: 'सिंक हो रहा है…',
    pending: '{n} सिंक बाकी',
    offline: 'ऑफ़लाइन',
    offlineQueued: 'ऑफ़लाइन — आपके टैप सेव हैं, नेटवर्क आते ही सिंक होंगे।',
    waitingOnYou: '{n} बाकी',
    logout: 'लॉग आउट',
    language: 'भाषा',
    workingAs: 'किस रूप में काम',
    profile: 'प्रोफ़ाइल',
    sessionEnds: 'सेशन {time} पर खत्म होगा',
    sharedIdle: '15 मिनट इस्तेमाल न होने पर लॉग आउट',
    me: 'मैं',
    views: 'दृश्य',
    collapse: 'मेनू छोटा करें',
    expand: 'मेनू बड़ा करें',
    sync: 'सिंक',
    allSaved: 'सब बदलाव सेव · {time}',
    shiftRow: 'शिफ्ट',
    line: 'लाइन',
    updateReady: 'नया वर्ज़न तैयार है।',
    reload: 'रीलोड करें',
    liveOff: 'लाइव अपडेट रुका — दोबारा जुड़ रहा है…',
    sessionEnded: 'सेशन खत्म हुआ। फिर से PIN डालें।',
    theme: 'थीम',
    themeAuto: 'ऑटो',
    themeLight: 'लाइट',
    themeDark: 'डार्क',
    version: 'वर्ज़न {v}',
  },
  floor: {
    myWork: 'मेरा काम · {gate}',
    todo: 'करना है',
    issues: 'समस्या',
    done: 'हो गया',
    allOk: 'सब ठीक ({n})',
    confirmAllOk: '{n} लाइन ठीक करने के लिए फिर दबाएँ',
    waitingFor: 'पेंट / RM का इंतज़ार',
    toInspect: 'जाँच के लिए',
    clearableOf: '{n} में से · जाँच के लिए',
    pendingSince: 'सबसे पुराना {time} से ({age})',
    keyboardHint: 'कीज़: ↑ ↓ चुनें · O ठीक · P आंशिक · S कमी/रोक · A सब ठीक',
    allClear: 'सब साफ़',
    noTodo: 'कुछ बाकी नहीं। प्लानर के प्लान प्रकाशित करते ही नई लाइन यहाँ दिखेगी।',
    noIssues: 'कोई समस्या नहीं',
    noIssuesHint: 'आंशिक या {bad} वाली लाइनें अपडेट होने तक यहाँ रहती हैं।',
    noDone: 'अभी कुछ नहीं',
    noDoneHint: 'ठीक की गई लाइनें यहाँ आती हैं।',
    plusAdded: 'प्लान में +{n} जुड़े',
    moreArrived: '+{n} और जाँच के लिए',
    whyTitle: '{label}: कारण?',
    oneTapSaves: 'एक टैप में सेव।',
    partialTitle: '{label}: कितने ठीक हैं?',
    mustBeLess: '{max} से कम होना चाहिए। पूरे {max} के लिए ठीक दबाएँ।',
    splitComing: '{ok} ठीक, {rest} आने बाकी',
    splitHeld: '{ok} ठीक, {rest} रोके गए',
    reasonForHeld: 'रोके गए यूनिट का कारण',
    observationTitle: 'टिप्पणी जोड़ें (ज़रूरी नहीं)',
    lockedQuality: 'क्वालिटी जाँच चुकी है। {name} को कॉल करें, एक्सटेंशन {ext}।',
    lockedStarted: 'लाइन यह मॉडल शुरू कर चुकी है। {name} को कॉल करें, एक्सटेंशन {ext}।',
    lockedGeneric: 'लॉक',
    saved: '{model}: {what}',
    markedOk: '{n} लाइन {gate} ठीक',
    planNotPublished: 'आज का प्लान अभी प्रकाशित नहीं हुआ।',
    planNotPublishedHint: 'प्लानर तैयार कर रहे हैं। प्रकाशित होते ही यहाँ दिखेगा।',
    noPlan: 'इस शिफ्ट का प्लान अभी नहीं है।',
    edit: 'जवाब बदलें',
    cancelEdit: 'जवाब रखें',
  },
  planner: {
    title: 'आज का प्लान',
    planFor: 'प्लान · {line} · {shift} · {date}',
    emptyTitle: 'इस शिफ्ट का प्लान अभी नहीं है',
    emptyHint: 'पिछला प्लान कॉपी करके बदलें, या नया बनाएँ।',
    copyFrom: '{date} का प्लान कॉपी करें ({n} लाइन)',
    copyYesterday: 'कल का प्लान कॉपी करें',
    startNew: 'नया प्लान बनाएँ',
    publish: 'प्रकाशित करें',
    publishConfirm: '{n} लाइन सभी विभागों को भेजने के लिए फिर दबाएँ',
    published: '{time} पर {name} ने प्रकाशित किया। बदलाव तुरंत सभी विभागों तक जाते हैं।',
    draft: 'ड्राफ़्ट — प्रकाशित करने तक विभाग यह प्लान नहीं देखते।',
    addLine: 'लाइन जोड़ें',
    pickModel: 'मॉडल और रंग चुनें',
    mostUsed: 'सबसे ज़्यादा',
    allModels: 'सभी मॉडल',
    howMany: 'कितने?',
    addToPlan: 'प्लान में जोड़ें',
    added: '{model} {qty} जुड़ा। {who} अब देख रहे हैं।',
    addedDraft: '{model} {qty} ड्राफ़्ट में जुड़ा।',
    departments: 'पेंट और RM',
    changeQty: 'मात्रा बदलें',
    newQty: 'नई प्लान मात्रा',
    nowQty: 'अभी {n}',
    qtyUpHint: 'जिन विभागों ने पुरानी मात्रा पास की थी, अतिरिक्त यूनिट उनकी सूची में लौटेंगे।',
    qtyDownHint: 'पास की गई मात्रा नई प्लान तक सीमित होगी।',
    qtyChanged: '{model}: प्लान अब {qty}',
    cancelLine: 'लाइन रद्द करें',
    tapAgainCancel: 'रद्द करने के लिए फिर दबाएँ',
    cancelled: '{model} सभी विभागों की सूची से हटाया गया',
    runOrderNote:
      'ऊपर से नीचे चलने का क्रम। क्रम बदलने के लिए खींचें या तीर दबाएँ। इतिहास के लिए मॉडल दबाएँ।',
    priorityHint: 'प्राथमिकता बदलने के लिए दबाएँ',
    moveUp: 'ऊपर करें',
    moveDown: 'नीचे करें',
    drag: 'क्रम बदलने के लिए खींचें',
    plan: 'प्लान',
    ready: 'तैयार',
    waiting: 'इंतज़ार',
    onHold: 'रुका',
    dashboard: 'डैशबोर्ड',
    otherDay: 'दूसरा दिन',
    currentShift: 'चालू शिफ्ट',
    viewing: '{date} · {shift} देख रहे हैं',
    notCurrent: 'यह चालू शिफ्ट नहीं है।',
    noModels: 'अभी कोई मॉडल नहीं',
    noModelsHint: 'एडमिन से मॉडल जोड़ने को कहें (सेटअप → मॉडल)।',
  },
  supervisor: {
    title: 'चलाने के लिए तैयार',
    comingUp: 'आगे आने वाले',
    readyTab: 'तैयार',
    started: 'शुरू हो गया',
    start: 'शुरू करें',
    nothingReady: 'अभी कुछ तैयार नहीं',
    nothingReadyHint: 'पेंट, RM और क्वालिटी के पास करते ही लाइन यहाँ दिखेगी।',
    nothingComing: 'कुछ बाकी नहीं',
    nothingComingHint: 'हर लाइन में तैयार मात्रा है।',
    noneStarted: 'कोई लाइन शुरू नहीं',
    noneStartedHint: 'तैयार लाइन पर शुरू करें दबाएँ।',
    readyOf: '{qty} में से तैयार',
    readyFull: 'तैयार, पूरा प्लान',
    startedToast: '{model} {line} पर शुरू',
    newlyReady: 'अभी पास हुआ',
    inRunOrder: '{line} · प्लानर के क्रम में',
  },
  dashboard: {
    title: 'लाइव डैशबोर्ड',
    subtitle: '{line} · {shift} · {date} · विभागों के टैप के साथ अपडेट',
    todaysPlan: 'आज का प्लान',
    planLines: '{n} लाइन',
    ready: 'तैयार',
    pctOfPlan: 'प्लान का {p}%',
    atGate: '{gate} पर',
    onHold: '{n} रुके',
    waiting: '{n} इंतज़ार में',
    clear: 'साफ़',
    whereTitle: 'आज के {n} यूनिट कहाँ हैं',
    legendReady: 'तैयार',
    legendWait: 'अपडेट का इंतज़ार',
    legendHold: 'रुका',
    whereNote:
      'हर न-तैयार यूनिट एक बार गिना जाता है, उस गेट पर जो उसे रोक रहा है। चारों समूह हमेशा प्लान के बराबर होते हैं।',
    lines: 'प्लान लाइनें',
    linesFiltered: 'प्लान लाइनें · {filter}',
    filterReady: 'तैयार मात्रा वाली',
    filterGate: '{gate} पर रुकी',
    showAll: 'सभी दिखाएँ',
    rowHint: 'इतिहास के लिए पंक्ति दबाएँ',
    colModel: 'मॉडल',
    colPlan: 'प्लान',
    colGates: 'P · R · Q',
    colReady: 'तैयार',
    colStatus: 'स्थिति',
    colWhy: 'किसने रोका',
    holds: 'रुके हुए · {n}',
    noHolds: 'अभी कुछ नहीं रुका।',
    holdSince: '{time} से ({age}) · ज़िम्मेदार {name}',
    waitingUpdate: 'अपडेट का इंतज़ार · {n}',
    noneWaiting: 'हर विभाग अप-टू-डेट है।',
    progress: 'विभाग की प्रगति',
    progressNote: 'हर विभाग ने प्लान का कितना हिस्सा पास किया।',
    overview: 'सारांश',
    holdsTab: 'रुके हुए',
    whyHold: '{gate} · {reason} · {qty} रुके {age}',
    whyPartial: '{gate} · प्लान से {qty} कम · {age}',
    whyPending: '{gate} · अपडेट नहीं · {age}',
    whyStarted: '{time} पर शुरू',
    reports: 'रिपोर्ट',
    unbalanced: 'कुल जोड़ मेल नहीं खा रहा — IT को बताएँ।',
  },
  laptop: {
    name: 'फ़्लोर डिस्प्ले',
    title: '{line} तैयारी',
    subtitle: '{plant} · {shift} · {date}',
    fullscreen: 'फ़ुल स्क्रीन',
    exit: 'बाहर',
    open: 'फ़्लोर डिस्प्ले खोलें',
    cta: 'शॉप-फ़्लोर मॉनिटर या TV के लिए फ़ुल-स्क्रीन लाइव बोर्ड — स्क्रीन से जुड़े लैपटॉप पर खोलें।',
  },
  timeline: {
    title: 'इतिहास',
    gates: 'गेट',
    readyOf: '{q} में से {r} तैयार · {p} प्राथमिकता',
    waitingOwner: '{age} से इंतज़ार · {name}, एक्सटेंशन {ext}',
    lockedHint: 'पेंट और RM के कुछ यूनिट पास होने पर खुलेगा',
    cleared: '{n} पास',
    undone: 'वापस लिया',
    'plan.publish': 'प्लान प्रकाशित',
    'plan.create': 'प्लान बना',
    'item.add': 'प्लान में जोड़ा',
    'item.qty': 'मात्रा बदली {from} → {to}',
    'item.priority': 'प्राथमिकता {to}',
    'item.cancel': 'लाइन रद्द',
    'item.start': 'लाइन शुरू',
    'item.unstart': 'शुरुआत वापस ली',
    'plan.reorder': 'क्रम बदला',
    gateOk: '{gate} ठीक',
    gatePartial: '{gate} आंशिक: {qty} में से {ok}',
    gateQPartial: 'क्वालिटी आंशिक रोक: {ok} ठीक, बाकी रोके ({reason})',
    gateBlocked: '{gate} {label} ({reason})',
    gateObservation: 'क्वालिटी ठीक, टिप्पणी: {reason}',
  },
  reports: {
    title: 'रिपोर्ट',
    daily: 'दैनिक तैयारी सारांश',
    date: 'तारीख',
    from: 'से',
    to: 'तक',
    downloadPdf: 'PDF डाउनलोड',
    downloadXlsx: 'Excel डाउनलोड',
    pareto: 'कारण पैरेटो (7 दिन)',
    paretoNone: 'इस अवधि में कोई रोक या कमी नहीं।',
    count: 'बार',
    qty: 'यूनिट',
    ttc: 'पास करने में औसत समय',
    ttcNote: 'गेट के काम शुरू कर सकने से पूरी मात्रा पास होने तक।',
    samples: '{n} लाइन',
    pilot: 'पायलट मेट्रिक्स',
    pilotNote: 'पायलट के सफलता मानक, अपने-आप मापे गए।',
    within30: 'प्रकाशन के 30 मिनट में हर गेट ने अपडेट की लाइनें',
    firstReady: 'प्रकाशन → पहली तैयार लाइन (माध्य)',
    activeRoles: 'हर फ़्लोर भूमिका के रोज़ सक्रिय यूज़र',
    balanced: 'दिन जब डैशबोर्ड कुल = प्लान कुल',
    target: 'लक्ष्य {t}',
    minutes: '{n} मिनट',
    noData: 'अभी डेटा नहीं',
    shiftTotals: 'शिफ्ट {code}: प्लान {plan}, तैयार {ready}',
    rostered: '{r} में से {a} सक्रिय',
    perDay: 'हर दिन',
  },
  admin: {
    title: 'सेटअप',
    subtitle: '{plant} के यूज़र, मॉडल, कारण, शिफ्ट और डिवाइस',
    users: 'यूज़र',
    models: 'मॉडल',
    reasons: 'कारण',
    shifts: 'शिफ्ट',
    lines: 'लाइनें',
    devices: 'साझा डिवाइस',
    audit: 'ऑडिट लॉग',
    settings: 'प्लांट',
    addUser: 'यूज़र जोड़ें',
    editUser: 'यूज़र बदलें',
    name: 'नाम',
    mobile: 'मोबाइल',
    titleField: 'पद',
    department: 'विभाग',
    extField: 'एक्सटेंशन',
    rolesField: 'भूमिकाएँ',
    languageField: 'भाषा',
    initialPin: 'अभी PIN सेट करें (प्लांट के फ़ोन के लिए)',
    initialPinHint: 'खाली छोड़ें तो यूज़र OTP से अपना PIN बनाएगा।',
    resetPin: 'PIN रीसेट',
    resetPinConfirm: 'फिर दबाएँ: {name} अगली बार नया PIN बनाएँगे',
    pinReset: '{name} का PIN रीसेट। अगली बार वे नया PIN बनाएँगे।',
    unlock: 'अनलॉक',
    unlocked: '{name} अनलॉक',
    lockedUntil: '{time} तक लॉक',
    noPinYet: 'PIN नहीं बना',
    deactivate: 'निष्क्रिय करें',
    activate: 'सक्रिय करें',
    inactive: 'निष्क्रिय',
    photo: 'फ़ोटो',
    uploadPhoto: 'फ़ोटो अपलोड करें',
    saved: 'सेव हो गया',
    addModel: 'मॉडल जोड़ें',
    modelName: 'मॉडल का नाम',
    sweep: 'स्वीप (mm)',
    finish: 'रंग / फ़िनिश',
    colour: 'रंग का नमूना',
    blades: 'ब्लेड',
    addReason: 'कारण जोड़ें',
    reasonEn: 'लेबल (अंग्रेज़ी)',
    reasonHi: 'लेबल (हिंदी)',
    icon: 'आइकन',
    maxReasons: 'हर गेट पर अधिकतम 6 सक्रिय।',
    addShift: 'शिफ्ट जोड़ें',
    code: 'कोड',
    start: 'शुरू',
    end: 'खत्म',
    addLine: 'लाइन जोड़ें',
    addDevice: 'साझा डिवाइस जोड़ें',
    deviceLabel: 'डिवाइस का नाम',
    deviceRole: 'विभाग',
    pairingCode: 'जोड़ने का कोड: {code}',
    pairingHint:
      'डिवाइस पर लॉग इन स्क्रीन → “विभाग के साझा डिवाइस के रूप में सेट करें” खोलें और यह कोड डालें। 24 घंटे मान्य।',
    newCode: 'नया कोड',
    paired: '{time} पर जोड़ा',
    notPaired: 'अभी जोड़ा नहीं',
    lastSeen: 'आखिरी बार {time}',
    unpair: 'हटाएँ',
    plantName: 'प्लांट का नाम',
    timezone: 'टाइमज़ोन',
    auditWhen: 'कब',
    auditWho: 'किसने',
    auditWhat: 'क्या किया',
    auditEntity: 'रिकॉर्ड',
    loadMore: 'और दिखाएँ',
    active: 'सक्रिय',
    required: 'ज़रूरी',
  },
  errors: {
    forbidden: 'आपकी भूमिका यह नहीं कर सकती।',
    not_found: 'यह लाइन अब नहीं है।',
    conflict: 'किसी और ने इसे बदला। स्क्रीन अपडेट हो गई।',
    cancelled: 'प्लानर ने यह लाइन रद्द कर दी।',
    started: 'लाइन यह मॉडल शुरू कर चुकी है।',
    quality_acted: 'क्वालिटी यह लाइन जाँच चुकी है।',
    quality_locked: 'पेंट और RM के कुछ यूनिट पास होने पर क्वालिटी खुलेगी।',
    qty_out_of_range: 'यह मात्रा संभव नहीं।',
    reason_required: 'कारण चुनें।',
    reason_not_allowed: 'ठीक के लिए कारण की ज़रूरत नहीं।',
    reason_invalid: 'यह कारण हटा दिया गया। दूसरा चुनें।',
    undo_expired: 'वापस लेने का समय निकल गया। बदलें इस्तेमाल करें।',
    undo_not_allowed: 'अब इसे वापस नहीं लिया जा सकता।',
    not_ready: 'इस लाइन पर अभी कुछ तैयार नहीं।',
    plan_exists: 'इस शिफ्ट का प्लान पहले से है।',
    plan_not_draft: 'प्लान पहले ही प्रकाशित है।',
    plan_draft: 'प्लान अभी प्रकाशित नहीं हुआ।',
    plan_empty: 'प्रकाशित करने से पहले कम से कम एक लाइन जोड़ें।',
    no_copy_source: 'कॉपी करने के लिए पुराना प्लान नहीं।',
    model_inactive: 'यह मॉडल अब सक्रिय नहीं है।',
    invalid: 'सेव नहीं हुआ। फिर कोशिश करें।',
    network: 'कनेक्शन नहीं। इस डिवाइस पर सेव है, बाद में सिंक होगा।',
    rejected: 'सेव नहीं हुआ: {reason}',
  },
  welcome: {
    title: 'अपना प्लांट सेट करें',
    intro: 'नया CLEAR सर्वर। प्लांट और पहला एडमिन बनाएँ — एक मिनट लगेगा।',
    step: 'चरण {n} / 3',
    codeTitle: 'सेटअप कोड',
    codeHint: 'टीम द्वारा आपके साथ साझा किया गया 6 अंकों का कोड।',
    codeWrong: 'यह सेटअप कोड सही नहीं है। टीम द्वारा साझा किया गया कोड जाँचें।',
    plantTitle: 'प्लांट',
    plantName: 'प्लांट का नाम',
    plantNameHint: 'जैसे लोग बुलाते हैं, जैसे “हरिद्वार फ़ैन प्लांट”।',
    lineName: 'पहली असेंबली लाइन',
    lineNameHint: 'और लाइनें बाद में जोड़ सकते हैं।',
    timezone: 'टाइमज़ोन',
    starterReasons: 'मानक कारण चिप्स से शुरू करें (पेंट, RM, क्वालिटी)',
    adminTitle: 'पहला एडमिन',
    adminName: 'एडमिन का नाम',
    adminMobile: 'एडमिन का मोबाइल नंबर',
    adminMobileHint: 'एडमिन इसी नंबर, एक बार के कोड और 4 अंकों के PIN से लॉग इन करेगा।',
    adminJobTitle: 'पद',
    create: 'प्लांट और एडमिन बनाएँ',
    next: 'आगे',
    back: 'वापस',
    done: 'प्लांट बन गया। अब एडमिन खाता चालू करें।',
    otpDefault: 'अभी OTP डिफ़ॉल्ट कोड {code} है (SMS अभी नहीं)।',
    already: 'यह प्लांट पहले से सेट है।',
  },
  onboarding: {
    title: 'शुरुआत',
    intro: 'ये एक बार पूरे करें, फिर फ़्लोर CLEAR इस्तेमाल कर सकता है।',
    users: 'लोग जोड़ें और हर एक को भूमिका दें',
    usersHint: 'प्लानर, पेंट, RM, क्वालिटी, लाइन सुपरवाइज़र, मैनेजमेंट।',
    models: 'असेंबल होने वाले मॉडल जोड़ें',
    modelsHint: 'नाम, स्वीप साइज़, रंग और फ़ोटो।',
    reasons: 'हर गेट के कारण चिप्स जाँचें',
    shifts: 'शिफ्ट का समय जाँचें',
    devices: 'विभाग के साझा फ़ोन जोड़ें (ज़रूरी नहीं)',
    activate: 'हर व्यक्ति ऐप खोले → “पहली बार?” → मोबाइल → OTP {code} → PIN।',
    go: 'खोलें',
    hide: 'छिपाएँ',
    userAdded: '{name} जुड़ गए। वे ऐप खोलें → पहली बार → मोबाइल → OTP → PIN चुनें।',
  },
  demo: {
    badge: 'डेमो',
    banner: 'डेमो डेटा — नमूना प्लांट, सबका PIN 1234। यहाँ कुछ भी असली नहीं है।',
    tryIt: 'नमूना डेटा के साथ डेमो देखें →',
    reset: 'डेमो डेटा रीसेट करें',
    realApp: 'असली ऐप पर जाएँ',
    resetDone: 'डेमो नमूना प्लांट पर रीसेट हो गया।',
  },
  landing: {
    login: 'लॉग इन',
    tryDemo: 'डेमो देखें',
    headline: 'लाइन शुरू होने से पहले जानें कि आज का कितना प्लान चल सकता है।',
    lede: 'पेंट, RM और क्वालिटी एक से तीन टैप में अपना गेट पास करते हैं। हर प्लान लाइन को लाइव तैयार, इंतज़ार या रुका स्टेटस मिलता है, और प्रोडक्शन हेड को एक भरोसेमंद तैयार संख्या दिखती है — फ़ॉलो-अप कॉल की ज़रूरत नहीं।',
    heroNote: 'फ़ोन या लैपटॉप ब्राउज़र · कुछ इंस्टॉल नहीं · हिंदी और English',
    howTitle: 'एक नियम, एक संख्या',
    howLede: 'लाइन तभी चल सकती है जब पेंटेड पार्ट्स, कच्चा माल और क्वालिटी पास — तीनों तैयार हों।',
    gatePaint: 'पेंट',
    gatePaintText: 'पेंट शॉप ठीक, आंशिक या कमी मार्क करता है।',
    gateRm: 'RM',
    gateRmText: 'स्टोर ठीक, आंशिक या उपलब्ध नहीं मार्क करता है।',
    gateQuality: 'क्वालिटी',
    gateQualityText: 'QA वही जाँचता है जो पेंट और RM ने पास किया है।',
    gateReady: 'तैयार',
    gateReadyText: 'तैयार मात्रा = सबसे कम पास मात्रा। डैशबोर्ड का जोड़ हमेशा प्लान के बराबर।',
    rolesTitle: 'हर भूमिका की एक स्क्रीन',
    rolesLede: 'PIN के तुरंत बाद हर व्यक्ति अपनी काम की सूची पर पहुँचता है। कोई मेनू सीखना नहीं।',
    rolePlanner: 'प्लानर तीन टैप में आज का प्लान प्रकाशित करता है: कल का कॉपी, बदलाव, प्रकाशित।',
    roleGates: 'पेंट, RM, क्वालिटी: ठीक टैप करें या कारण चिप चुनें। 10 सेकंड में वापस लें।',
    roleSupervisor: 'लाइन सुपरवाइज़र क्रम से देखता है क्या चलाने को तैयार है, और शुरू टैप करता है।',
    roleMgmt: 'मैनेजमेंट तैयार बनाम प्लान, हर रोक के साथ किसे कॉल करें, और रोज़ की रिपोर्ट देखता है।',
    roleAdmin: 'एडमिन लोग, मॉडल और कारण सेट करता है, और फ़्लोर डिस्प्ले मॉनिटर पर लगाता है।',
    floorTitle: 'शॉप फ़्लोर के लिए बना',
    f1: '1 से 3 टैप',
    f1Text: 'ठीक एक टैप में। फ़्लोर पर टाइपिंग नहीं — नंबर पैड और कारण चिप्स।',
    f2: 'ऑफ़लाइन भी चलता है',
    f2Text: 'नेटवर्क जाने पर टैप फ़ोन में सेव रहते हैं और अपने-आप सिंक होते हैं।',
    f3: 'हर जगह लाइव',
    f3Text: 'किसी भी विभाग के टैप करते ही हर स्क्रीन कुछ सेकंड में अपडेट।',
    f4: 'एक नज़र में साफ़',
    f4Text: 'हर स्टेटस पर रंग, आइकन और शब्द, दस्ताने वाले हाथों के लिए बड़े बटन, हिंदी और English।',
    f5: 'फ़्लोर डिस्प्ले',
    f5Text: 'शॉप-फ़्लोर मॉनिटर के लिए फ़ुल-स्क्रीन बोर्ड — सभी लाइनें, रोक और प्रगति।',
    f6: 'सुरक्षित',
    f6Text: 'PIN लॉग इन, 5 गलत कोशिश पर लॉक, हर बदलाव का ऑडिट, डेटा भारत में।',
    startTitle: 'प्लांट की शुरुआत',
    s1: 'प्लांट सेट करें',
    s1Text: 'पहला एडमिन प्लांट, उसकी लाइन और शिफ्ट बनाता है।',
    s2: 'लोग और भूमिकाएँ जोड़ें',
    s2Text: 'एडमिन हर व्यक्ति को मोबाइल और भूमिका के साथ जोड़ता है, और असेंबल होने वाले मॉडल भी।',
    s3: 'सब चालू करें',
    s3Text: 'मोबाइल → एक बार का कोड → 4 अंकों का PIN। उसके बाद सिर्फ़ PIN।',
    ctaTitle: 'नमूना प्लांट के साथ देखें',
    ctaText:
      'डेमो में हैवेल्स सीलिंग-फ़ैन का प्लान है — 8 लाइनें, 12,000 यूनिट। हर नमूना यूज़र का PIN 1234 है।',
    footer: 'SaarthiOS CLEAR · AI Gurukul Pvt Ltd',
    previewTitle: 'लाइन 2 · शिफ्ट A',
    previewReady: 'तैयार',
    previewPlan: 'प्लान',
    previewHold: 'रुका',
  },
  trial: {
    title: 'ट्रायल अवधि समाप्त',
    body: 'SaarthiOS CLEAR की आपकी ट्रायल अवधि समाप्त हो गई है। एक्सेस रिन्यू करने के लिए एडमिन से संपर्क करें।',
    logout: 'लॉग आउट',
  },
  a11y: {
    delete: 'अंक हटाएँ',
    menu: 'प्रोफ़ाइल खोलें',
    close: 'बंद करें',
    skip: 'सामग्री पर जाएँ',
  },
};
